import { useTranslation } from "react-i18next"
import Oops from "../Oops/Oops"
import { OopsLocalError } from "../OopsLocalError"
import { ApolloError } from "@apollo/client/errors"

interface WorksetsErrorProps {
  error?: ApolloError
}

export const WorksetsError = (props: WorksetsErrorProps) => {
  const { error } = props
  const { t } = useTranslation("worksets")

  return error ? <OopsLocalError error={error} heading={t("error.fetchError")} /> : <Oops />
}
